import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  GetFileSummaryExpress,
  orderSliceSelector,
} from "../../features/orders/orderSlice";

const EmailDocumentsDialog = ({
  setEmailDocuments,
  isEmailSelected,
  setisEmailSelected,
  setValidationCss,
  register,
  addEmailClick,
  isEmailValid,
  emailErrorMessage,
  setEmailValid,
  emailList,
  setEmailList,
  isemailIDSelected,
  setisemailIDSelected,
  isDocSelected,
  setisDocSelected,
  docErrorMessage,
  setdocErrorMessage,
  sendEmailClick,
  t,
  errors,
  handleClick,
  ToastContainer,
}) => {
  return (
    <>
      <ToastContainer />
      <div
        className={
          isEmailSelected === 1
            ? "flex justify-left items-center mb-[30px] ml-8 mt-6 select-emails pr-8"
            : "hidden mb-[30px] ml-8 mt-6 select-emails"
        }
      >
        <div className="flex flex-col">
          <p className="mb-4">{t("EmailSendMessage")}</p>
          <div className="flex flex-row">
            <div className="size__md text-left">
              <label
                htmlFor="corporation_name"
                className="block font-[600] mb-2"
              >
                {t("email")} <address></address>
              </label>
              <input
                type="text"
                id="email"
                {...register("email")}
                name="email"
                placeholder="abc@domain.com"
                style={setValidationCss(errors?.email)}
              />
            </div>
            <button
              onClick={addEmailClick}
              className="!px-[8.5px] btn__secondary h-10 ml-4 py-[9px] self-end w-[170px]"
            >
              {t("AddEmail")}
            </button>
          </div>
          <div className="flex flex-row">
            <div className="size__md">
              <span className="font-semibold text-secondary-red">
                {isEmailValid ? "" : emailErrorMessage || t("invalidEmailError")}
              </span>
            </div>
          </div>
          <div className="flex flex-col mt-4">
            {emailList != null &&
              emailList.length != 0 &&
              emailList.map((item, i) => (
                <span key={i}>
                  <div className="flex flex-row ml-[3px] mr-[31px]">
                    <input
                      className="custom__checkbox mr-[14px] self-center"
                      type="checkbox"
                      name="emailArray"
                      defaultChecked={true}
                      value={item.email}
                      {...register(`emailArray`)}
                      onChange={handleClick}
                    />
                    <p className="font-semibold">
                      {item.username + " (" + item.email + ")"}
                    </p>
                  </div>
                </span>
              ))}

            <span className="font-semibold text-secondary-red">
              {isemailIDSelected && t('selectEmailErrorMsg')}
              {isDocSelected && docErrorMessage}
            </span>
          </div>

          <div className="flex justify-end mt-6 space-x-2">
            <button
              id="send-selected-documents"
              className="btn__primary mr-1 px-4 py-2"
              onClick={sendEmailClick}
            >
              {t("SendEmail")}
            </button>
            <button
              className="btn__tertiary px-4 py-2 text-secondary-red"
              onClick={() => setEmailDocuments(false)}
            >
              {t("cancel")}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default EmailDocumentsDialog;
